<template>
  <div>
      <v-dialog v-model="data.dialogShow" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary" class="elevation-2">
          <v-btn icon dark @click="data.dialogShow = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Printing Sertifikat dan Deteksi</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>
        <div style="height:650px;">            
          <!-- {{printExerciseCode}} -->
          <iframe
            id="printExcercise"
            width="100%"
            height="600"
            frameborder="0"
            :src="data.printSource"
          ></iframe>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//import ApiService from "@/common/api.service";
import { format } from "date-fns";
import numeral from "numeral";

export default {
  props: {
    data: Object
  },
  data: () => ({}),
  filters: {
    date: function(value) {
      return format(new Date(value), "DD-MM-YYYY");
    },
    number: function(value) {
      return numeral(value).format("0,0.00");
    },
    numberN3: function(value) {
      return numeral(value).format("0,0.000");
    },
    numberN0: function(value) {
      return numeral(value).format("0,0");
    }
  },
  methods: {}
};
</script>
